import { render, staticRenderFns } from "./RequestsDetails.vue?vue&type=template&id=388e8a2d&scoped=true&"
import script from "./RequestsDetails.vue?vue&type=script&lang=js&"
export * from "./RequestsDetails.vue?vue&type=script&lang=js&"
import style0 from "./RequestsDetails.vue?vue&type=style&index=0&id=388e8a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e8a2d",
  null
  
)

export default component.exports